const nlDiensten = {
  seo: {
    title: "Onze diensten | Kozijn-, raam- en schuifpuireparatie Eindhoven",
    description: "Bekijk al onze diensten: kozijnreparatie PVC, alu, hout, schuifpui, draaikiep, slot en glas. Gratis offerte binnen 24 uur. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    current: "Onze diensten",
  },
  hero: {
    pill: "ONZE DIENSTEN",
    h1: "Onze diensten in Eindhoven",
    subhead: "Specialist in kozijn-, raam- en schuifpuireparatie in Eindhoven en omstreken. PVC, aluminium en hout — vakkundig hersteld, met 10 jaar garantie.",
    ctaPrimary: "Gratis offerte",
    ctaPhone: "040 798 7470",
  },
  intro: {
    h2: "Vakkundig raamherstel voor heel Eindhoven",
    p1: "Ramen Repair Eindhoven is gespecialiseerd in het herstellen van problemen aan kozijnen, ramen, schuifpuien, draaikiepramen, deuren en beslag. Of het nu gaat om kunststof, aluminium of hout — onze monteurs zijn opgeleid voor elk type.",
    p2: "Wij geloven in herstellen in plaats van vervangen. Een kapot sluitmechanisme, klemmend raam of versleten beslag is meestal prima te repareren. U bespaart honderden euro's en uw kozijn gaat weer jaren mee.",
    p3: "Onze monteurs werken met originele onderdelen van Roto, Winkhaus, Maco en Sobinco. Wij rijden uit met een volledig uitgeruste bestelwagen, waardoor de meeste reparaties in één bezoek klaar zijn. Vakmanschap, eerlijke prijzen en 10 jaar schriftelijke garantie.",
  },
  dienstenRows: {
    h2: "Wat wij voor u doen",
  },
  werkwijze: {
    h2: "Hoe wij werken — in 4 stappen",
    steps: [
      { nr: "01", title: "Aanvraag", desc: "Bel of formulier, wij reageren binnen enkele uren" },
      { nr: "02", title: "Diagnose", desc: "Monteur komt gratis langs, eerlijke offerte op papier" },
      { nr: "03", title: "Reparatie", desc: "Vakkundig, originele onderdelen, vaak in 1 bezoek" },
      { nr: "04", title: "Garantie", desc: "Ondertekende garantieverklaring 10 jaar bij factuur" },
    ],
  },
  ctaBanner: {
    h2: "Hulp nodig bij uw raam, kozijn of schuifpui?",
    cta: "Bel 040 798 7470",
  },
};

export default nlDiensten;